/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


  



/* ALEA customs */
  const header = document.querySelector('.theme__header');
  if (!header) return;

  const root = document.documentElement;
  const THRESHOLD = 10; // px minimi di scroll prima di reagire
  let lastY = window.scrollY;
  let ticking = false;
  let hidden = false;
  let moveTimer;

  const setHidden = (next) => {
    if (next === hidden) return;
    hidden = next;

    root.classList.add('is-header-moving');
    root.classList.toggle('is-header-hidden', next);

    clearTimeout(moveTimer);
    moveTimer = setTimeout(() => root.classList.remove('is-header-moving'), 350);
  };

  function update() {
    ticking = false;

    // l'header non si nasconde se ha il focus dentro (tastiera / screen reader)
    if (header.matches(':focus-within')) {
      setHidden(false);
      return;
    }

    const y = Math.max(0, window.scrollY); // evita valori negativi (rubber-band iOS)
    const delta = y - lastY;
    if (Math.abs(delta) < THRESHOLD) return;
    lastY = y;

    // sopra l'altezza dell'header: sempre visibile
    setHidden(y > header.offsetHeight && delta > 0);
  }

  window.addEventListener('scroll', () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(update);
  }, { passive: true });

  header.addEventListener('focusin', () => setHidden(false));



  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
